import { PowerbiTablaComponent } from './components/powerbi-tabla/powerbi-tabla.component';
import { NgModule } from '@angular/core';
import { SharedModule } from '../../../core/modules/shared.module';
import { RouterModule } from '@angular/router';
import { ActivosComponent } from './activos.component';
import { ActivosService } from './activos.service';
import { ActivosDetalleComponent } from './detalle/activos-detalle.component';
import { ActivosEditarComponent } from './editar/activos-editar.component';
import { KpisTablaComponent } from './components/kpis-tabla/kpis-tabla.component';
import { KpisService } from './components/kpis-tabla/kpis.service';
import { PowerBiService } from './components/powerbi-tabla/powerbi.service';

const routes = [
    {
        path     : 'activos',
        component: ActivosComponent
    },
    {
        path     : 'activos/detalle/:idActivo',
        component: ActivosDetalleComponent
    },
    {
        path     : 'activos/editar/:idActivo',
        component: ActivosEditarComponent
    },
    {
        path     : 'activos/nuevo',
        component: ActivosEditarComponent
    }
];

@NgModule({
    imports: [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    declarations: [
        ActivosComponent,
        ActivosDetalleComponent,
        ActivosEditarComponent,
        KpisTablaComponent,
        PowerbiTablaComponent
    ],
    providers: [ActivosService, KpisService, PowerBiService]
})
export class ActivosModule {
}



// WEBPACK FOOTER //
// ./src/app/main/content/activos/activos.module.ts